
/* eslint-disable */
import { useState } from 'react';
import { setList } from 'api/actions';
import { useDispatch } from 'react-redux';
import useFormValidator from '../../../../../useFormValidator';
import { updateCalculation, getCalculation } from '../actions';

const useCalculationItemHeaderForm = (initialFormData, rules) => {

  const dispatch = useDispatch()

  const [formData, setFormData] = useState(initialFormData)

  const formValidator = useFormValidator(formData, rules)

  const onChangeText = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value 
    })
  } 

  const onChangeDecimal = (e) => {
    const isDecimal =
      e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value);
    
    if (isDecimal) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

    if (!e.target.value) {
      setFormData({
        ...formData,
        [e.target.name]: "",
      });
    }
  };

  const onBlurDecimal = (e,) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value ? e.target.value : "",
    });
  };

  const onChangeSelect = (key, callback) => (value) => {
    setFormData({
      ...formData,
      [key]: value.value
    });
    if(callback)
      callback({
        ...formData,
        [key]: value.value
      })
  }

  const onUpdateCalculation = (permitId, initialFeeId, calculationId,payload, callback) => {
    dispatch(updateCalculation(
      permitId, initialFeeId, calculationId,payload, callback
    ))
  }

  const updateListReducer = (constant, data) => {
    dispatch(setList(constant, data))
  }

  const onGetCalculation = (permitId, feeId, payload, callback) => {
    dispatch(getCalculation(permitId, feeId, payload, callback))
  }


  return {
    formData,
    setFormData,
    onChangeText,
    onChangeDecimal,
    onBlurDecimal,
    onChangeSelect,
    formValidator,
    onUpdateCalculation,
    updateListReducer,
    onGetCalculation
  }
}

export default useCalculationItemHeaderForm